import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialContractCloseFilterData } from "../../../utils/initialData";
import { handleDropdownClose } from "../../../utils/utils";
import ContractCloseFilterData from "./ContractCloseFilterData";

const ContractCloseFilter = ({
  filterData,
  activeTab,
  onSetFilterData,
  onCallApiAgain,
  from,
}) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  // 🔥 TEMP FILTER DATA - This prevents live filtering
  const [tempFilterData, setTempFilterData] = useState({});

  // ✅ CLEAN FILTER DATA
  const getCleanFilterData = (data) => {
    const cleaned = {};
    Object.keys(data || {}).forEach((key) => {
      if (
        !key.endsWith("_label") &&
        data[key] !== "" &&
        data[key] !== null &&
        data[key] !== undefined
      ) {
        cleaned[key] = data[key];
      }
    });
    return cleaned;
  };

  const getFilterCount = (data) => {
    return Object.keys(getCleanFilterData(data)).length;
  };

  const count = getFilterCount(filterData);

  // Sync temp data when modal opens
  useEffect(() => {
    if (isSidebarOpen) {
      setTempFilterData({ ...filterData });
      setSelectedSaveFilterId("");
    }
  }, [isSidebarOpen]);

  useEffect(() => {
    const handleClose = () => setIsSidebarOpen(false);
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    const cleanedData = getCleanFilterData(tempFilterData);

    localStorage.setItem("filterData", JSON.stringify(cleanedData));
    onSetFilterData(tempFilterData);        // Apply filters
    onCallApiAgain(cleanedData);            // Call API only on Filter button

    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleTempFilterChange = (value, name) => {
    setTempFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      current_phase: value?.current_phase || "",
      current_phase_label: value?.current_phase_label || "",
      next_action: value?.next_action || "",
      next_action_label: value?.next_action_label || "",
      advisor: value?.advisor || "",
      created_start_date: value?.created_start_date,
      created_end_date: value?.created_end_date,
      created_at: value?.created_at,
      status: value?.status,
    };

    setTempFilterData(dataToSet);
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(getCleanFilterData(dataToSet));
    setIsSidebarOpen(false);
  };

  const saveSearchFilterData = {
    current_phase: tempFilterData?.current_phase,
    next_action: tempFilterData?.next_action,
    advisor: tempFilterData?.advisor,
    created_start_date: tempFilterData?.created_start_date,
    created_end_date: tempFilterData?.created_end_date,
    created_at: tempFilterData?.created_at,
    status: tempFilterData?.status,
  };

  return (
    <div>
      <SavedFilterComponent
        from={from}
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialContractCloseFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={setSelectedSaveFilterId}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={setIsSidebarOpen}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          setTempFilterData(initialContractCloseFilterData); // Reset on cancel
        }}
        ref={dropdownRef}
        title={"Filter"}
        from={from}
        desc={`Enter Contract To Close information.`}
        onFilter={handleFilter}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={setSelectedSaveFilterId}
      >
        <ContractCloseFilterData
          isSidebarOpen={isSidebarOpen}
          filterData={tempFilterData}
          activeTab={activeTab}
          handleFilterChange={handleTempFilterChange}
          onSetFilterData={setTempFilterData}
          from={from}
        />
      </RightModal>
    </div>
  );
};

export default ContractCloseFilter;